import axios from "axios";
export const fetch = axios.create({
  baseURL: "https://official.layabox.com",
});



export const getFile = axios.create({
  baseURL: "https://ldc-1251285021.cos.ap-shanghai.myqcloud.com",
});